module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA2BAMAAABD+RaIAAAAAXNSR0IB2cksfwAAAC1QTFRFAAAAIHb/H3X/H3b/H3b/H3b/IHD/H3b/HnX/IHX/H3b/IHj/H3b/H3b/IHj/H2aUfQAAAA90Uk5TAFC/7//PEMCwMNAgr/BAQqtoZwAAAJ5JREFUeJxjYFR2QQZhDGAggiLo4poAFi3pZEACLksgil02oIhmQRS7MKCIskEUo4kyQBSji0IUo4tCFGOIghVjiIIVo4lugChGFS05CVaMJgr1P5ooYy02UZideERL4CHphCSKFMDIolCDULlUEHWBiroQIUo7N2Dz8Wg4oKUSd2StqGBQi27AEOT0heQwVLDHHb2EAQM/WA5DBu4PAKMqajc/jnCJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/fil-movie@2x.png
// module id = 822
// module chunks = 0